import { ReactNode } from 'react';
import { Box, Fade, IconName, VStack } from '@wegroup/design-system';
import FlowProductsSideBarOverviewItems from '@flows/src/components/flow-products/sidebar/FlowProductsSideBarOverviewItems';
import FlowProductsSideBarLogo from '@flows/src/components/flow-products/FlowProductsSideBarLogo';

export interface FlowProductsSidebarItem {
  key: string;
  label: string;
  iconName?: IconName;
  subItems?: FlowProductsSidebarSubItem[];
}

export interface FlowProductsSidebarSubItem {
  key: string;
  label: string;
  index: number;
}

interface Props {
  items: FlowProductsSidebarItem[];
  isHidden?: boolean;
  cartComponent: ReactNode;
  basketItemsComponent: ReactNode;
}

const FlowProductsSidebar = ({
  items,
  isHidden,
  cartComponent,
  basketItemsComponent,
}: Props) => {
  const isBasketPage = window.location.pathname.includes('basket');
  const width = isBasketPage
    ? 'md'
    : isHidden
    ? '0'
    : { base: '2xs', laptopL: 'xs' };
  const borderRight = isHidden ? '0' : '1px';

  return (
    <Box position="relative" maxH="100vh">
      {/* This box makes sure the content on the right side is shown with the correct marginleft */}
      <Box w={width} visibility="hidden" transition="0.5s" />
      <VStack
        w={width}
        maxW={width}
        transition="0.5s"
        align="stretch"
        overflow="hidden"
        bg="white"
        pt="9"
        pb="4"
        h="100%"
        spacing="0"
        borderRight={borderRight}
        borderColor="gray.50"
        transform="auto"
        position="fixed"
        top="0"
      >
        <FlowProductsSideBarLogo />
        <VStack
          flexGrow="1"
          spacing="6"
          align="stretch"
          overflow="hidden"
          opacity={isBasketPage ? 0 : 1}
          maxH={isBasketPage ? '0%' : '100%'}
          transition="0.2s"
          mb={isBasketPage ? '0' : '8'}
        >
          <FlowProductsSideBarOverviewItems items={items} />
        </VStack>

        <Box flexGrow={1} overflowY="auto">
          <Fade in={isBasketPage} unmountOnExit>
            <VStack
              flexGrow="1"
              spacing="6"
              align="stretch"
              overflow="hidden"
              opacity={1}
              maxH={'100%'}
            >
              {basketItemsComponent}
            </VStack>
          </Fade>
        </Box>

        {cartComponent}
      </VStack>
    </Box>
  );
};

export default FlowProductsSidebar;
